import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "@/views/Home";

import Contact from "@/views/Contact";
import Tutorial from "@/views/Tutorial";
import Success from "@/views/Success";
import Submit from "../views/Submit";
import ResultPGMG from "../views/Result"
import Detail from "../views/Detail";
import TemResult from "../views/TemResult";
import experimentalValidation from "../views/experimentalValidation";

import test from "../views/test";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'index',
        redirect: '/home',
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
    },
    {
      path:"/ev"  ,
        name:'experimentalValidation',
        component:experimentalValidation
    },
    {
      path:"/test",
      component:test
    },
    {
      path:'/submit',
      name:'submit',
      component:Submit,
    },
    {
       path:'/TemResult' ,
        name:'TemResult',
        component:TemResult,
    },
    // {
    //     path:"/check",
    //     name:'check',
    //     component:Check,
    // },
    {
      path:'/result',
      name: 'result',
      component:ResultPGMG,
    },

    {
        path: '/contact',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/tutorial',
        name: 'Tutorial',
        component: Tutorial
    },
    {
        path:'/detail',
        name:'Detail',
        component:Detail,
    },
    {
        path: '/success',
        name: 'Success',
        component: Success
    },
    // {
    //     path: '/generation/:uuid',
    //     name: 'genResult',
    //     component: GenResult
    // },
]

const router = new VueRouter({
    routes,
    mode:'hash',
    // mode:'history',
    // base:'/DrugGen'
})

export default router
